import React, { FC } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';

import { filterNulls } from 'dibs-ts-utils/exports/filterNulls';
import { Link } from 'dibs-elements/exports/Link';
import ArrowRight from 'dibs-icons/exports/ArrowRight';

import { RailTag_tag } from './__generated__/RailTag_tag.graphql';

import styles from './RailTag.scss';

type RailTagProps = {
    tag: RailTag_tag;
};

export const RailTag: FC<RailTagProps> = ({ tag }) => {
    const similarItems = tag?.similarItems;
    const titleText = similarItems?.category?.name || similarItems?.category?.name || tag?.name;
    const items = similarItems?.items || [];

    if (!items.length) {
        return null;
    }

    const itemTiles = items.filter(filterNulls).map((item, index) => (
        <Link
            key={`rail-tag-item-${index}`}
            className={styles.projectTile}
            href={item.pdpURL || ''}
            ariaLabel={item.title || ''}
        >
            <img src={item.photos?.[0]?.versions?.[0]?.webPath || ''} className={styles.image} />
        </Link>
    ));

    return (
        <div className={styles.container}>
            <div className={styles.linkContainer}>
                <a href={similarItems?.searchUrl || ''}>
                    <span className={styles.searchLink}>{titleText}</span>
                    <ArrowRight className={styles.arrow} />
                </a>
            </div>
            <div className={styles.tileContainer}>{itemTiles}</div>
        </div>
    );
};

export default createFragmentContainer(RailTag, {
    tag: graphql`
        fragment RailTag_tag on TradePhotoTag {
            name
            similarItems {
                searchUrl
                category {
                    name
                }
                creator {
                    name
                }
                items {
                    pdpURL
                    title
                    photos(limit: 1) {
                        versions {
                            webPath
                        }
                    }
                }
            }
        }
    `,
});
